var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeleteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 3.37c-.863 0-1.578.635-1.703 1.463h3.406A1.72 1.72 0 0 0 10 3.37m0-1a2.723 2.723 0 0 0-2.71 2.463H3.834a.5.5 0 1 0 0 1h.706L5.657 16.23a1.5 1.5 0 0 0 1.491 1.34h5.704a1.5 1.5 0 0 0 1.491-1.34L15.46 5.833h.707a.5.5 0 1 0 0-1H12.71A2.72 2.72 0 0 0 10 2.37M6.651 16.122 5.557 5.931h8.887l-1.095 10.191a.5.5 0 0 1-.497.447H7.148a.5.5 0 0 1-.497-.447m2.682-7.605a.5.5 0 0 0-1 0v5.035a.5.5 0 1 0 1 0zm2-.5a.5.5 0 0 1 .5.5v5.035a.5.5 0 1 1-1 0V8.517a.5.5 0 0 1 .5-.5",
  clipRule: "evenodd"
})));
export default SvgDeleteIcon;